module.exports = __webpack_public_path__ + "static/longhorn19-e943da458d8b632b98e44d8e58c2202d.jpeg";